import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom';
import ArrowDown from '../../../assets/icons/ArrowDown';
import SubNavLink from '../SubNavLink';

function NavLinkCont({path="", title="", options=[]}) {
    const [subNavVisible, setSubNavVisible] = useState(true);
  
    const onCloseNav = (e) => {
        if(path === ""){e.preventDefault()}

        const btn = document.querySelector("#navBtn");
        if(btn){
            btn.checked = false;
            changeSubVisible()
        }
    }
   
    const setBySize = () => {
        if(window.innerWidth <= 1100){
            setSubNavVisible(false);
            
        }else{
            setSubNavVisible(true);
        
        }
    }
    useEffect(()=>{
        window.addEventListener("resize", ()=>{
            setBySize();
        })
        setBySize()
    },[]);

    const changeSubVisible = (e) =>{
        if(path === ""){e.preventDefault()}
        if(window.innerWidth <= 1100){
            setSubNavVisible(!subNavVisible)
        }
    }
  
  return (
    <li className='main-list h-full  flex relative'>
        <NavLink onClick={options?.length !== 0? (e)=>changeSubVisible(e):(e)=>onCloseNav(e)} to={path}  className='flex items-center '>
            <span className='text-white text-[18px] montserrat font-[500] max-[1280px]:text-[16px] max-[1240px]:text-[14px]'>{title}</span>
        {
            options?.length !== 0?
            <span className='w-[24px] h-[24px] link-icon '>
                <ArrowDown color="#fff" width={'24px'} height={'24px'}/>
            </span>:null
        }
        </NavLink>
        {
            options?.length !== 0 && subNavVisible?
            <ul className='top-[100px] left-[-50px]   absolute bg-white shadow shadow-xl w-[280px] py-[10px] flex-col gap-[7px] hidden max-[1100px]:flex sub-nav max-[1100px]:bg-white/20'>
                { 
                    options?.map((data, i)=>{
                        return(
                            <SubNavLink options={options} data={data} key={i} i={i} />
                        )
                    })
                }

            </ul>
            :null
        }
        {/* {
            options?.length !== 0 && subNavVisible?
            <ul className='top-[100px] left-[-30px] absolute bg-white shadow w-[200px] py-[10px] flex-col gap-[7px] hidden max-[1100px]:flex sub-nav max-[1100px]:bg-white/20'>
                {
                    options?.map((data, i)=>{
                        return(
                            <li key={i} className={`${i!== options?.length - 1?"border-b":""} group relative sub-nav-list max-[1100px]:w-full`}>
                                <div className='flex items-center justify-between px-[10px] w-full b'>
                                   {
                                        data?.options?.length !==0?
                                        <span  onClick={data?.options?.length !== 0? ()=>changeSub1Visible(data):()=>onCloseNav()} className='text-[15px] text-[#222] font-[600] group-hover:text-[--red] max-[1100px]:group-hover:text-white max-[1100px]:text-white' to={data?.path}>{data?.title}</span>:
                                        <NavLink  onClick={data?.options?.length !== 0? ()=>changeSub1Visible(data):()=>onCloseNav()} className='text-[15px] text-[#222] font-[600] group-hover:text-[--red]  max-[1100px]:group-hover:text-white max-[1100px]:text-white' to={data?.path}>{data?.title}</NavLink>
                                   }
                                    {
                                        data?.options?.length !== 0?
                                        <span className='w-[24px] h-[24px] rotate-[-90deg] link-icon '>
                                            <ArrowDown color={color?"var(--red)":"white"} width={'24px'} height={'24px'}/>
                                        </span>:null
                                    }
                                </div>
                                {
                                    data?.options?.length !==0 && subNav2Visible?
                                    <ul className='sub_sub_nav absolute right-[-200px] top-[-10px] bg-white shadow p-[10px] hidden flex-col gap-[7px] w-[200px] max-[1100px]:flex max-[1100px]:relative max-[1100px]:left-0 max-[1100px]:top-0 max-[1100px]:bg-white/20 max-[1100px]:shadow-none max-[1100px]:p-[10px] max-[1100px]:m-[10px] max-[1100px]:rounded-[5px]'>
                                       {
                                            data?.options?.map((item, j) => {
                                                return(
                                                    <li key={j} className={`${j!== data?.options?.length - 1?"border-b max-[1100px]:border-b-[--red]":""} group/child`}>
                                                        <NavLink className='text-[14px] text-[#222] font-[600] group-hover/child:text-[--red]' to={item?.path}>{item?.title}</NavLink>
                                                    </li>
                                                )
                                            })
                                        }
                                       
                                    </ul>:null
                                }
                            </li>
                        )
                    })
                }
            </ul>:null
        } */}
        
    </li>
  )
}

export default NavLinkCont
